import { render, staticRenderFns } from "./ProctoringDashboard.vue?vue&type=template&id=1f03544c"
import script from "./ProctoringDashboard.vue?vue&type=script&lang=js"
export * from "./ProctoringDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProctoringDashboard.vue?vue&type=style&index=0&id=1f03544c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports